import { render, staticRenderFns } from "./ProductCountChart.vue?vue&type=template&id=54257824&scoped=true"
import script from "./ProductCountChart.vue?vue&type=script&lang=js"
export * from "./ProductCountChart.vue?vue&type=script&lang=js"
import style0 from "./ProductCountChart.vue?vue&type=style&index=0&id=54257824&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54257824",
  null
  
)

export default component.exports